import { AppState } from "../typings/AppState";

export const initialState: AppState = {
  auth: {},
};
